import { Observable } from 'rxjs';

import { PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';

export type RecentSearchModel =
  RecentSearchHotel | RecentSearchCars | RecentSearchFlight | RecentSearchBus | RecentSearchPackages;

export type RecentSearchPackages = Readonly<{
  departuredate: string;
  arrivaldate: string;
  class: string;
  from: string;
  to: string;
  rooms: RecentSearchHotelRoom[];
  destination_location_type: string;
  destination_location_id: number;
  destination_hotel_name: string;
}> & RecentSearchBase;

export type RecentSearchHotel = Readonly<{
  checkin: string;
  checkout: string;
  destination: string;
  destination_name: string;
  hotel_name: string | null;
  isHotel: boolean;
  location_id: number;
  rooms: RecentSearchHotelRoom[];
}> & RecentSearchBase;

export type RecentSearchHotelRoom = Readonly<{
  guests: RecentSearchHotelGuest[]
}>;

export type RecentSearchHotelGuest = Readonly<{
  type: string;
  quantity: number;
  age: number | null
}>;

export type RecentSearchCars = Readonly<{
  dropoff: RecentLocationSearchCars;
  pickup: RecentLocationSearchCars;
}> & RecentSearchBase;

export type RecentLocationSearchCars = Readonly<{
  type: RecentCarsLocationType;
  time: string;
  coordinates: number[];
  code: string;
  place_id: string | number | null;
  placeName?: string;
}>;

export type RecentSearchFlight = Readonly<{
  arrivaldate: string;
  baggage: boolean;
  class: string;
  departuredate: string;
  roundtrip: boolean;
  from: string;
  to: string;
  travellers: RecentSearchFlightTraveller[];
}> & RecentSearchBase;

export type RecentSearchFlightTraveller = Readonly<{
  type: PassengerType;
  quantity: number;
}>;

export type RecentSearchBus = Readonly<{
  arrivaldate: string;
  departuredate: string;
  from: string;
  to: string;
  roundtrip: boolean;
  travellersQuantity: number;
}> & RecentSearchBase;

export type RecentSearchIds = Readonly<{
  searchIds: string[];
  placeIdSearchs: Observable<google.maps.GeocoderAddressComponent[]>[];
}>;

export enum RecentCarsLocationType {
  Code = 'Code',
  LatLon = 'LatLon'
}

type RecentSearchBase = Readonly<{
  _id?: string;
  user_id?: number | string;
  hash?: string;
  branch_code: string;
  countrycode: string;
  created_at: string;
  datatype: RecentSearchDataType;
}>;
